
import { Folder } from "@/types/folder"
import { DynamicParameter } from "@/types/insights"
import { Component, Prop, Vue, Watch } from "vue-property-decorator"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import FolderSetup from "@/components/Config/Views/FolderSetup.vue"
import FormattingRuleSetup from "@/components/Insights/ColumnFormatting/FormattingRuleSetup.vue"
import GlobalParameterSetup from "@/components/Config/Views/GlobalParameterSetup.vue"
import { Team } from "@/types"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"formatting-rule-setup": FormattingRuleSetup,
		"folder-setup": FolderSetup,
		"parameter-setup": GlobalParameterSetup
	}
})
export default class InsightSettings extends Vue {
	@Prop({ default: () => [] })
	folders!: Folder[]

	@Prop({ default: () => [] })
	teams!: Team[]

	@Prop({ default: () => [] })
	parameters!: DynamicParameter[]
}

